import { Empty, fmtDate } from "./TeamBits";

const ACTIONS = {
  requested: ["Requested access", "bg-amber-500"],
  approved: ["Approved", "bg-emerald-600"],
  reactivated: ["Reactivated", "bg-emerald-600"],
  rejected: ["Rejected", "bg-red-600"],
  suspended: ["Suspended", "bg-zinc-500"],
  role_changed: ["Role changed", "bg-sky-600"],
  invited: ["Invited", "bg-gold"],
  invite_resent: ["Invitation resent", "bg-gold"],
  invite_revoked: ["Invitation revoked", "bg-red-600"],
  invite_accepted: ["Joined via invitation", "bg-emerald-600"],
};

export function AccessHistory({ logs }) {
  if (!logs.length) return <Empty>No access activity yet.</Empty>;
  return (
    <ol className="relative space-y-4 border-l border-border pl-6" data-testid="access-history">
      {logs.map((l) => {
        const [label, dot] = ACTIONS[l.action] || [l.action, "bg-secondary"];
        return (
          <li key={l.id} className="relative" data-testid={`log-${l.id}`}>
            <span className={`absolute -left-[31px] top-1.5 h-3 w-3 rounded-full ring-4 ring-background ${dot}`} />
            <p className="text-sm">
              <span className="font-semibold">{label}</span> · {l.target_name || l.target_email}
              {l.target_name && <span className="text-muted-foreground"> ({l.target_email})</span>}
            </p>
            <p className="text-xs text-muted-foreground">
              by {l.actor_name || l.actor_email} · {fmtDate(l.created_at)}{l.details ? ` · ${l.details}` : ""}
            </p>
          </li>
        );
      })}
    </ol>
  );
}
